import { Logos } from '@draftkings/event-page-widget-contracts';
import { Scoreboard, TeamLogoProps } from '@draftkings/scoreboards';
import { ParsedEvent } from '../../contracts/parsers/IParser';
import { EventTeams } from '../EventTeams';
import { EventTimer } from '../EventTimer';
import type { LocalizationConfig } from '@draftkings/sportsbook-labels';
import './index.scss';

type EventHeaderProps = {
    event: ParsedEvent;
    leagueName: string;
    staticS3Host: string;
    logosMap: Logos | undefined;
    isTeamSwap: boolean;
    getTeamLogo: (props: TeamLogoProps) => JSX.Element;
    renderStrapline: () => JSX.Element;
    isSgpEnabled: boolean;
    isSwooshTeamLogosEnabledForEventPage?: boolean;
    swooshBaseUrl: string;
    locale: string;
    localizationConfig: LocalizationConfig;
};

export function EventHeader({
    leagueName,
    staticS3Host,
    logosMap,
    event,
    isTeamSwap,
    getTeamLogo,
    renderStrapline,
    isSgpEnabled,
    isSwooshTeamLogosEnabledForEventPage,
    swooshBaseUrl,
    locale,
    localizationConfig
}: EventHeaderProps) {
    const dict = localizationConfig.eventPage;
    const scoreboardWrapperClassname = isSgpEnabled ? 'scoreboards-wrapper-sgp' : 'scoreboards-wrapper';
    return (
        <>
            {!event.scoreboardData && !isSgpEnabled && (
                <div className="ep-event-header" data-testid="ep-event-header">
                    <div className="ep-event-header__league-name" data-testid="ep-event-header-league-name">
                        {leagueName}
                    </div>
                    <div className="ep-event-header__body">
                        <div className="ep-event-header__body-teams">
                            <EventTeams
                                event={event}
                                logosMap={logosMap}
                                staticS3Host={staticS3Host}
                                isTeamSwap={isTeamSwap}
                                isSwooshTeamLogosEnabledForEventPage={isSwooshTeamLogosEnabledForEventPage}
                                swooshBaseUrl={swooshBaseUrl}
                            />
                        </div>
                        <div className="ep-event-header__body-timer" data-testid="ep-event-header-timer">
                            {event.status === 'STARTED' ? (
                                dict.liveText
                            ) : (
                                <EventTimer
                                    eventStartDate={event.startEventDate}
                                    startsIn={dict.startsIn}
                                    daysText={dict.daysText}
                                    dayText={dict.dayText}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
            {!isSgpEnabled && renderStrapline()}
            {event.scoreboardData && (
                <div className={scoreboardWrapperClassname} data-testid="scoreboards-wrapper">
                    <Scoreboard
                        {...event.scoreboardData}
                        shouldSkipNavigation={true}
                        getTeamLogo={getTeamLogo}
                        locale={locale}
                    />
                </div>
            )}
        </>
    );
}
